import LoadingButton from "@mui/lab/LoadingButton";
import { ButtonProps } from "@mui/material";
import { useFormStatus } from "hooks/useFormStatus";

export const SubmitButton: React.FC<ButtonProps> = function (props) {
  const { isLoading } = useFormStatus();

  return (
    <LoadingButton {...props} type="submit" loading={isLoading}>
      {props.children}
    </LoadingButton>
  );
};
